module.exports = __webpack_public_path__ + "img/bg.a2bb9f25.webp";